import { _axiosInstance } from '@/tools/declare/global/$axiosInstance';
enum POINT {
  BASE = 'layout',
  CONFIG = '/config',
  DATASET = '/data',
}
const layoutMethods = () => ({
  getConfig: async (): Promise<any> => {
    try {
      console.log('its pzc layout')
      const { data } = await _axiosInstance.get(
        `${POINT.BASE + POINT.CONFIG}`
      );
      return data;
    } catch (e) {
      return { data: [] };
    }
  },
  getDataSet: async (): Promise<any> => {
    try {
      const { data } = await _axiosInstance.get(
        `${POINT.BASE + POINT.DATASET}`
      );
      return data;
    } catch (e) {
      return { data: [] };
    }
  },
});

export const defaultLayoutService = {
  ...layoutMethods(),
};



// WEBPACK FOOTER //
// ./src/services/api/newDefaultLayout/defaultLayout.ts